import { CognitoUser, CognitoRefreshToken } from 'amazon-cognito-identity-js';
import userPool from './userPool';
import { STORAGE_TOKEN, STORAGE_REFRESH_TOKEN } from '../constants';
import { History } from 'history';

export const refreshToken = async (history?: History | string[]): Promise<void> => {
  try {
         const refreshTokenString = sessionStorage.getItem(STORAGE_REFRESH_TOKEN);

    if (!refreshTokenString) {
      console.error('No refresh token found');
      sessionStorage.removeItem(STORAGE_TOKEN);
      return;
    }

    const userData = {
      Username: 'username', // You need to provide the user's username here
      Pool: userPool,
    };

    const user = new CognitoUser(userData);
    const refreshTokenObject = new CognitoRefreshToken({ RefreshToken: refreshTokenString as string });

    return new Promise((resolve, reject) => {
      user.refreshSession(refreshTokenObject, (err, session) => {
        if (err) {
          console.error('Error refreshing token:', err);
          if (err.message && err.message.includes('400 Bad Request')) {
            console.error('User session has expired. Logging out...');
            user.signOut();
            sessionStorage.removeItem(STORAGE_TOKEN);
            sessionStorage.removeItem(STORAGE_REFRESH_TOKEN);
            if (history) {
              history.push('/auth');
            }
          } else {
            console.error('Other error occurred. Logging out...');
            sessionStorage.removeItem(STORAGE_TOKEN);
            sessionStorage.removeItem(STORAGE_REFRESH_TOKEN);
            if (history) {
              history.push('/auth');
            }
          }

          reject(err);
        } else {
          const newIdToken = session.getIdToken().getJwtToken();
          sessionStorage.setItem(STORAGE_TOKEN, newIdToken);
          resolve();
        }
      });
    });
  } catch (error) {
    console.error('An unexpected error occurred:', error);
    if (history) {
      history.push('/auth');
    }
  }
};
